module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "signboard",
    staticClass: "d-flex row mx-0 signboard"
  }, [_c('div', {
    staticClass: "col-xl-5 col-lg-6 col-12 px-0 relative d-flex mb-5 mb-lg-0 mt-lg-0 mt-5"
  }, [_c('div', {
    staticClass: "preview-image-box",
    style: ({
      backgroundColor: "var(--color-regional-menu)",
      backgroundImage: ("url(" + _vm.background + ")")
    })
  }), _c('div', {
    staticClass: "preview-content-box d-flex px-lg-5 px-3 mt-lg-5 mb-lg-5 mt-4 mb-4"
  }, [_c('div', {
    staticClass: "d-flex flex-column align-items-start"
  }, [_c('img', {
    staticClass: "preview-content-box--text",
    attrs: {
      "src": require("./text.svg")
    }
  }), _c('span', {
    staticClass: "preview-content-box--region mb-4"
  }, [_c('span', {
    staticClass: "relative px-0 py-0"
  }, [_c('span', {
    style: ({
      backgroundColor: "var(--color-regional-menu)",
      backgroundImage: ("url(" + _vm.background + ")")
    })
  }, [_vm._v(_vm._s(_vm.data.area))])])]), _c('div', {
    staticClass: "d-flex align-items-center mt-lg-auto"
  }, [_c('div', {
    staticClass: "preview-content-box--eventsCount-count me-3"
  }, [_vm._v(_vm._s(_vm.data.eventsCount.value))]), _c('div', {
    staticClass: "preview-content-box--eventsCount-name"
  }, [_vm._v(_vm._s(_vm.data.eventsCount.name))])]), _c('div', {
    staticClass: "d-flex mt-4"
  }, [_c('AppButtonNew', {
    attrs: {
      "to": {
        name: "events"
      }
    }
  }, [_vm._v("перейти в каталог")])], 1)])])]), _c('div', {
    staticClass: "col-xl-7 col-lg-6 col-12 px-0 signboard-slider"
  }, [_c('ContentSlider', {
    attrs: {
      "items": _vm.data.items
    },
    scopedSlots: _vm._u([{
      key: "slideItem",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "d-flex slide"
        }, [_c('AppPicture', {
          staticClass: "slide-image",
          attrs: {
            "image": slotProps.slide.images.original,
            "alt": slotProps.slide.title
          }
        }), _c('div', {
          staticClass: "slide-content mt-lg-5 mt-4 mb-auto px-lg-5 px-3"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: "blog-article",
              params: {
                id: slotProps.slide.id
              }
            }
          }
        }, [_c('h2', {
          staticClass: "slide-title ui_lines-limit-3 mb-3"
        }, [_vm._v(_vm._s(slotProps.slide.title))]), _c('p', {
          staticClass: "slide-announce"
        }, [_vm._v(_vm._s(slotProps.slide.announce))])])], 1)], 1)]
      }
    }, {
      key: "underBulletContent",
      fn: function() {
        return [_c('div', {
          staticClass: "d-flex col-xl-4 flex-nowrap col-12 px-0 signboard-blog-link--wrapper"
        }, [_c('router-link', {
          staticClass: "signboard-blog-link",
          attrs: {
            "to": {
              path: "blog"
            }
          }
        }, [_vm._v("ВСЕ АНОНСЫ")])], 1)]
      },
      proxy: true
    }])
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beacdb12","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppDefaultLayout/components/sections/signboardNew/SignboardNew.vue
// module id = 5570ecdd39f9f79b8587
// module chunks = 0